import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'; //NOSONAR
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {
  getAllDataFromLocalForage,
} from 'ngrx-store-persist';
import localForage from 'localforage';
// main.ts
import moment from 'moment';
import 'moment/locale/ar';
import 'moment/locale/fr';
import 'moment/locale/de';

// optional default
moment.locale('en');

if (environment.enableSentry) {
  setTimeout(() => {
    const feedbackElement = document.querySelector("#feedback");
    if(feedbackElement){
      Sentry.init({
        dsn: 'https://a6ffeecfab628c2d0ba5e01de77da91d@o1362515.ingest.us.sentry.io/4508618980130816',
        release: `v${environment.HEROKU_RELEASE_VERSION}`,
        environment: environment.env,
        integrations: [
          Sentry.browserTracingIntegration(),
          // Sentry.browserProfilingIntegration(),
          // Sentry.replayIntegration({
          //   maskAllText: false,
          //   blockAllMedia: false
          // }),
      
          Sentry.feedbackIntegration({
            autoInject: false
          }).attachTo(feedbackElement, {
            formTitle: "Report a Bug!",
          }),
        ],
        tracesSampleRate: 1.0,
        // profilesSampleRate: 1.0,
        // replaysSessionSampleRate: 0.1,
        // replaysOnErrorSampleRate: 1.0,
      });
    }
  }, 200);
}

// Set up localForage config 
localForage.config({
  driver: localForage.INDEXEDDB,
  name: 'holcim',
});

getAllDataFromLocalForage({
  keys: ['userDetails', 'httpUrl'],
} as any).then(() => {
  if (environment.production) {
    enableProdMode();
  }
  if (
    !window.location.href.includes('localhost') 
  ) {
    window.console.log = () => {};
  }
  platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch((err) => console.log(err));//NOSONAR
});



